/**
 * @deprecated This hook is deprecated. Use useAccountLinks instead.
 *
 * The invitation system has been replaced with the unified Account Links system.
 * All team hierarchy and account linking functionality is now in useAccountLinks.
 *
 * Migration guide:
 * - sentInvitations → pendingSent (from useAccountLinks)
 * - receivedInvitations → pendingReceived (from useAccountLinks)
 * - pendingInvitationsCount → pendingCount (from useAccountLinks)
 * - inviteSupervisor/inviteManager → sendLinkRequest with relationshipType
 * - acceptInvitation → acceptLink
 * - declineInvitation → declineLink
 * - cancelInvitation → cancelRequest
 */

import { useEffect } from 'react';
import { useAccountLinks } from './useAccountLinks';

export function useInvitations() {
  useEffect(() => {
    console.warn(
      '[DEPRECATED] useInvitations is deprecated. Use useAccountLinks instead. ' +
      'See useInvitations.jsx for migration guide.'
    );
  }, []);

  const {
    pendingSent,
    pendingReceived,
    pendingCount,
    loading,
    sendLinkRequest,
    acceptLink,
    declineLink,
    cancelRequest
  } = useAccountLinks();

  // Map to legacy interface for backwards compatibility
  return {
    sentInvitations: pendingSent,
    receivedInvitations: pendingReceived,
    pendingInvitationsCount: pendingCount,
    loading,
    // These now log warnings and do nothing
    inviteSupervisor: async () => {
      console.warn('inviteSupervisor is deprecated. Use useAccountLinks.sendLinkRequest with relationshipType instead.');
    },
    inviteManager: async () => {
      console.warn('inviteManager is deprecated. Use useAccountLinks.sendLinkRequest with relationshipType instead.');
    },
    acceptInvitation: acceptLink,
    declineInvitation: declineLink,
    cancelInvitation: cancelRequest
  };
}
